import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import {
  AnyProgressBarWidget,
  AnyProgressBarWidgetStyles,
  DottedJoin,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import {
  selectedWidget,
  setQuantityWidgetStyleSettings,
} from "../../../store/slices/widgets";
import {
  IgColorPickerGroup,
  IgColorPickerGroupItems,
} from "../../../utils/IgColorPickerGroup";

interface ProgressBarWidgetAppearanceSettingsProps {
  configType: "desktop" | "mobile";
}
export const DiscountProgressBarWidgetAppearanceSettings = ({
  configType,
}: ProgressBarWidgetAppearanceSettingsProps) => {
  const progressBarWidget = useSelector(selectedWidget) as AnyProgressBarWidget;
  const dispatch = useDispatch();
  const items = useMemo<IgColorPickerGroupItems>(() => {
    return [
      [
        {
          key: "barActiveColor",
          label: "Bar Active",
          path: `config[${configType}].styles.bar.activeColor`,
          value:
            progressBarWidget?.config[configType]?.styles?.bar?.activeColor ||
            progressBarWidget?.config.desktop?.styles?.bar?.activeColor ||
            "",
        },
        {
          key: "barInactiveColor",
          label: "Bar Inactive",
          path: `config[${configType}].styles.bar.inactiveColor`,
          value:
            progressBarWidget?.config[configType]?.styles?.bar?.inactiveColor ||
            progressBarWidget?.config.desktop?.styles?.bar?.inactiveColor ||
            "",
        },
        {
          key: "barActiveColor",
          label: "Bar Background",
          path: `config[${configType}].styles.bar.backgroundColor`,
          value:
            progressBarWidget?.config[configType]?.styles?.bar
              ?.backgroundColor ||
            progressBarWidget?.config.desktop?.styles?.bar?.backgroundColor ||
            "",
        },
      ],
      [
        {
          key: "breakpointBackgroundColor",
          label: "Breakpoint Active",
          path: `config[${configType}].styles.breakpoint.activeColor`,
          value:
            progressBarWidget?.config[configType]?.styles?.breakpoint
              ?.activeColor ||
            progressBarWidget?.config.desktop?.styles?.breakpoint
              ?.activeColor ||
            "",
        },
        {
          key: "breakpointBackgroundColor",
          label: "Breakpoint Inactive",
          path: `config[${configType}].styles.breakpoint.inactiveColor`,
          value:
            progressBarWidget?.config[configType]?.styles?.breakpoint
              ?.inactiveColor ||
            progressBarWidget?.config.desktop?.styles?.breakpoint
              ?.inactiveColor ||
            "",
        },
      ],
      [
        {
          key: "containerBackgroundColor",
          label: "Container Background",
          path: `config[${configType}].styles.container.backgroundColor`,
          value:
            progressBarWidget?.config[configType]?.styles?.container
              ?.backgroundColor ||
            progressBarWidget?.config.desktop?.styles?.container
              ?.backgroundColor ||
            "",
        },
        {
          key: "tooltipBackgroundColor",
          label: "Tooltip Background",
          path: `config[${configType}].styles.tooltip.backgroundColor`,
          value:
            progressBarWidget?.config[configType]?.styles?.tooltip
              ?.backgroundColor ||
            progressBarWidget?.config.desktop?.styles?.tooltip
              ?.backgroundColor ||
            "",
        },
      ],
    ];
  }, [progressBarWidget]);

  const onFieldChange = (
    key: DottedJoin<AnyProgressBarWidgetStyles>,
    value: string
  ) => {
    dispatch(setQuantityWidgetStyleSettings({ key, value }));
  };

  return (
    <Grid container item direction={"column"} rowGap={2}>
      <Grid item>
        <IgTypography sx={{ fontWeight: 600, fontSize: "16px" }}>
          Bar Colors
        </IgTypography>
      </Grid>
      <Grid item>
        <IgColorPickerGroup
          id={"progress-bar-widget"}
          items={items}
          onChange={onFieldChange}
          disabled={false}
        />
      </Grid>
    </Grid>
  );
};
